export const NEWSPAPER = 0
export const INSERT = 1
export const ALL = 2

export const types = {
  [NEWSPAPER]: 'Huvudtidningar',
  [INSERT]: 'Bilagor',
  [ALL]: 'Alla'
}